// 모듈B — 제품(샷)별 융합·판정 결과 카탈로그
// 화면1에서 선택한 샷으로 드릴다운하면 화면3·4가 이 카탈로그를 조회해 해당 제품 결과를 표시.
// 실제 API 연동 시 getProduct(shotId) 만 백엔드 조회로 교체하면 됨.

// 기본 가중치·임계값 (화면3과 동일)
const DEFAULT_WEIGHTS = { alpha: 0.35, beta: 0.35, gamma: 0.30 };
const THRESHOLD = 0.5;

// shotId 기준 원천 데이터
// scores: 모달리티별 불량 점수(0~1, 1에 가까울수록 불량)
// defects: 불량 유형별 확률(0~1)
// contribution: 판정 기여도(%) — 합 100
const raw = {
  'S-10248': {
    productId: 'P-8848', confidence: 93.6,
    scores: { vision: 0.72, process: 0.48, thermal: 0.81 },
    defects: { warpage: 0.78, shrinkage: 0.61, dimension: 0.44, surface: 0.22, shortShot: 0.12, flash: 0.08 },
    contribution: { thermal: 46, vision: 31, process: 23 },
  },
  'S-10247': {
    productId: 'P-8847', confidence: 96.1,
    scores: { vision: 0.21, process: 0.33, thermal: 0.28 },
    defects: { warpage: 0.18, shrinkage: 0.12, dimension: 0.16, surface: 0.15, shortShot: 0.07, flash: 0.05 },
    contribution: { process: 40, vision: 33, thermal: 27 },
  },
  'S-10246': {
    productId: 'P-8846', confidence: 95.2,
    scores: { vision: 0.30, process: 0.26, thermal: 0.35 },
    defects: { warpage: 0.20, shrinkage: 0.18, dimension: 0.14, surface: 0.19, shortShot: 0.08, flash: 0.06 },
    contribution: { thermal: 38, vision: 34, process: 28 },
  },
  'S-10244': {
    productId: 'P-8844', confidence: 88.5,
    scores: { vision: 0.55, process: 0.52, thermal: 0.40 },
    defects: { warpage: 0.46, shrinkage: 0.38, dimension: 0.49, surface: 0.21, shortShot: 0.10, flash: 0.09 },
    contribution: { process: 37, vision: 34, thermal: 29 },
  },
  'S-10243': {
    productId: 'P-8843', confidence: 91.2,
    scores: { vision: 0.68, process: 0.71, thermal: 0.30 },
    defects: { warpage: 0.41, shrinkage: 0.35, dimension: 0.72, surface: 0.28, shortShot: 0.15, flash: 0.12 },
    contribution: { process: 44, vision: 33, thermal: 23 },
  },
  'S-10242': {
    productId: 'P-8842', confidence: 96.4,
    scores: { vision: 0.24, process: 0.29, thermal: 0.33 },
    defects: { warpage: 0.19, shrinkage: 0.14, dimension: 0.13, surface: 0.17, shortShot: 0.06, flash: 0.05 },
    contribution: { thermal: 36, vision: 33, process: 31 },
  },
  'S-10241': {
    productId: 'P-8841', confidence: 92.8,
    scores: { vision: 0.45, process: 0.40, thermal: 0.90 },
    defects: { warpage: 0.74, shrinkage: 0.58, dimension: 0.40, surface: 0.20, shortShot: 0.10, flash: 0.07 },
    contribution: { thermal: 52, vision: 26, process: 22 },
  },
};

// 융합 점수 S 와 최종 판정(result)을 기본 가중치로 미리 계산해 부착
export const productCatalog = Object.fromEntries(
  Object.entries(raw).map(([shotId, p]) => {
    const S =
      DEFAULT_WEIGHTS.alpha * p.scores.vision +
      DEFAULT_WEIGHTS.beta * p.scores.process +
      DEFAULT_WEIGHTS.gamma * p.scores.thermal;
    const fusionScore = Math.round(S * 1000) / 1000;
    return [shotId, { ...p, shotId, fusionScore, result: fusionScore >= THRESHOLD ? 'NG' : 'OK' }];
  })
);

// 제품 선택 드롭다운용 목록 (매칭 성공 = 융합 가능한 제품만)
export const productList = Object.values(productCatalog).map((p) => ({
  shotId: p.shotId,
  productId: p.productId,
  result: p.result,
  fusionScore: p.fusionScore,
}));

// 드릴다운 기본 샷
export const defaultDrilldownShotId = 'S-10248';

// shotId 로 제품 결과 조회 (없으면 기본 제품)
export const getProduct = (shotId) =>
  productCatalog[shotId] || productCatalog[defaultDrilldownShotId];

// 드릴다운 가능 여부 (카탈로그에 존재 = 동일 제품 매칭 성공)
export const canDrilldown = (shotId) => Boolean(productCatalog[shotId]);
